import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {useUpdateEffect} from 'react-use';
import '../../style/Checkbox.less';

export default function Checkbox(props) {
    const [value, setValue] = useState(props.value);

    const [isValid, setIsValid] = useState(true);

    const inputRef = useRef(null);

    useEffect(() => {
        if (props.focusOnLoad) {
            inputRef.current.focus();
        }
    }, []);

    useUpdateEffect(() => {
        validate();
    }, [value, props.isValid]);

    function handleChange() {
        // Hand text input value to given onChange method
        if (props.onChange) {
            props.onChange(
                {
                    ...props,
                    value: !value
                }
            );
        }
    }

    function validate() {
        if (props.isValid === false) {
            setIsValid(false);
        } else {
            const hasValue = props.value !== undefined && props.value !== null && props.value !== '';
            setIsValid(!props.required || hasValue);
        }
    }

    useUpdateEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div className="form-group form-checkbox">
            {props.label &&
            <>
                <input
                    id={props.id}
                    type="checkbox"
                    checked={value || ''}
                    readOnly={props.readonly}
                    onKeyPress={props.onKeyPress}
                    className={`sr-only ${isValid ? '' : 'is-invalid'}`}
                    onChange={handleChange}
                    ref={inputRef}
                />
                <label htmlFor={props.id}>
                    <span className="label-text">{props.label}</span>
                </label>
            </>
            }
        </div>
    );
};

Checkbox.propTypes = {
    name: PropTypes.string,
    label: PropTypes.any,
    value: PropTypes.bool,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    readonly: PropTypes.bool,
    errorMessage: PropTypes.string,
    isValid: PropTypes.bool
};
